import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsScrollerUsersOpenGame = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/scrollers/open-game/list`, {params});
};